import React from "react";
import CompanyDash from "../Dash/CompanyDash";
import NoviRadnik from "../Moduli/NoviRadnik";
import PromenaPina from "../Moduli/PromenaPina";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import Dialog from "material-ui/Dialog";
import Rezervacije from "../Izvestaji/Rezervacije";
import * as Colors from "material-ui/styles/colors";
import axios from "axios";
import MasterDash from "../Dash/MasterDash";
import CloseIcon from "material-ui/svg-icons/navigation/close";
import RefreshIndicator from 'material-ui/RefreshIndicator';

const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('id_token')}`}

};
const muiTheme = getMuiTheme({
	palette: {
		textColor: Colors.darkBlack,
		primary1Color: Colors.lightGreen600,
		primary2Color: Colors.indigo700,
		accent1Color: Colors.lightGreen600,
		pickerHeaderColor: Colors.darkBlack,
		alternateTextColor: Colors.white
	},
	appBar: {
		height: 45
	}
});

export default class HomeScreen extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			height: 0,
			PorudzbaNarednaModalState: false,
			porudzNaredData: [],
			PorudzbaTekucaModalState: false,
			porudzTekucaData: [],
			PromenaPinaModalState: false,
			NoviRadnikModalState: false,
			Loading: 'loading',
			dashData: [
    {
      logo: {
        type: 'Buffer',
        data: []
      },
      IskorisceniObrociProslaNedelja: 0,
      RezervisaniObrociProslaNedelja: 0,
      idFirme: 1,
      Naziv: 'Firma',
      panelPoruka: '',
      onlineStatus: 'loading',
      pinPromeneTekuceNedelje: '',
      'broj rezervacija': '0',
      'obrok nedelje': '',
      activeMobileUsers: 0,
      activePanelUsers: 0,
      '!obrok nedelje': ''
    },
    {
      logo: {
        type: 'Buffer',
        data: []
      },
      IskorisceniObrociProslaNedelja: 0,
      RezervisaniObrociProslaNedelja: 0,
      idFirme: 2,
      Naziv: 'Firma',
      panelPoruka: '',
      onlineStatus: 'loading',
      pinPromeneTekuceNedelje: '',
      'broj rezervacija': '0',
      'obrok nedelje': '',
      activeMobileUsers: 0,
      activePanelUsers: 0,
      '!obrok nedelje': ''
    },

  ]
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	PorudzbaNarednaModalHandleClose = () => {
		this.setState({ PorudzbaNarednaModalState: false });
	};

	PorudzbaTekucaModalHandleClose = () => {
		this.setState({ PorudzbaTekucaModalState: false });
	};

	PromenaPinaModalHandleClose = () => {
		this.setState({ PromenaPinaModalState: false });
	};

	PromenaPinaModalHandleOpen = (id, pin) => {
		this.setState({
			PromenaPinaModalState: true,
			PromenaPinaSelektovanaFirma: id,
			PromenaPinaPin: pin
		});
	};

	NoviRadnikModalHandleClose = () => {
		this.setState({ NoviRadnikModalState: false });
	};

	getFirmeDash = () => {
		var query = "https://www.pricacatering.net:8443/firmeDash";
		axios.get(query, config).then(res => {
			const data = res.data.data;
			this.setState({ dashData: data,Loading:'hide' });

		});
	};

	getPorudzbaNaredna = id => {
		var query = "https://www.pricacatering.net:8443/PorudzbaNaredna/" + id;
		axios.get(query, config).then(res => {
			const data = res.data.data;
			this.setState({
				porudzNaredData: data,
				PorudzbaNarednaModalState: true
			});
			//console.log(data);
		});
	};

	getPorudzbaTekuca = id => {
		var query = "https://www.pricacatering.net:8443/PorudzbaTekuca/" + id;
		axios.get(query, config).then(res => {
			const data = res.data.data;
			this.setState({
				porudzTekucaData: data,
				PorudzbaTekucaModalState: true
			});
			//console.log(data);
		});
	};

	getNoviRadnik = id => {
		var query = "https://www.pricacatering.net:8443/RadneJedinice/" + id;
		axios.get(query, config).then(res => {
			const data = res.data.data;
			this.setState({
				radneJediniceData: data,
				NoviRadnikSelektovanaFirma: id,
				NoviRadnikModalState: true
			});
			//console.log(data);
		});
	};

	getIzmeniRadnika = id => {
			this.setState({
				IzmeniRadnikaSelektovanaFirma: id,
				IzmeniRadnikaModalState: true
			});
			console.log("IzmeniRadnika");
	};

	//containerElement={<Link to={"/IzmeniRadnika/"+props.idfirme "/" + props.filter} />}
	putPromeniPin = (idFirme, pin) => {
		const body = { firma_id: idFirme, pin: pin };
		var query = "https://www.pricacatering.net:8443/promeniPin";
		axios.put(query, body, config).then(res => {
			this.setState({
				PromenaPinaModalState: false
			});
			window.history.pushState("Home", "storyDash", "/"); // Ocisti link adresu od parametara promene pina
			this.getFirmeDash(); // Osvezi podatke firmi za DashBoard
		});
	};

	putPanelPoruka = (idFirme, poruka) => {
		const body = { firma_id: idFirme, poruka: poruka };
		var query = "https://www.pricacatering.net:8443/promeniPanelPoruku";
		axios.put(query, body, config).then(res => {
			this.getFirmeDash(); // Osvezi podatke firmi za DashBoard
		});
	};

		sentPanelPoruka = (idFirme) => {
		const body = { firma_id: idFirme };

		var query = "https://www.pricacatering.net:8443/sentPanelPoruka";
		axios.put(query, body, config).then(res => {
			alert(res.data.message);
			this.getFirmeDash(); // Osvezi podatke firmi za DashBoard
		}).catch(function (error) {

   alert(error.response.data.message)
  });
	};

	postNoviRadnik = (
		ime,
		prezime,
		idbroj,
		idfirme,
		idufirmi,
		idradnejedinice,
		idmenadzera
	) => {
		const body = {
			ime: ime,
			prezime: prezime,
			idbroj: idbroj,
			idfirme: idfirme,
			idufirmi: idufirmi,
			idradnejedinice: idradnejedinice,
			idmenadzera: idmenadzera
		};
		var query = "https://www.pricacatering.net:8443/dodajRadnika";
		console.log(body);
		axios.post(query, body, config).then(res => {
			console.log(res);
			this.setState({
				NoviRadnikModalState: false
			});
			this.getFirmeDash(); // Osvezi podatke firmi za DashBoard
		});
	};

	putUpdateMenu = idFirme => {
		const body = { firma_id: idFirme };
		var query = "https://www.pricacatering.net:8443/UpdateMenu";
		axios.put(query, body, config).then(res => {
			this.getFirmeDash(); // Osvezi podatke firmi za DashBoard
		});
	};

	componentDidMount() {
		this.getFirmeDash();
				this.updateWindowDimensions();
		window.addEventListener("resize", this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}
		componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);

	}
	render() {
		let Firme = [];
		let ukupnoRezervacija = 0;
		let ukupnoAktivnihKorisnika = 0;
		let ukupnoAktivnihMobilnihKorisnika = 0;
		let ukupnoKoristenoProslaNedelja = 0;
		let ukupnoRezervisanoProslaNedelja = 0;

		for (let i = 0; i < this.state.dashData.length; i++) {
			try {
				ukupnoRezervacija += Number(
					this.state.dashData[i]["broj rezervacija"]
				);
			} catch (e) {}
			try {
				ukupnoAktivnihKorisnika += Number(
					this.state.dashData[i]["activePanelUsers"]
				);
			} catch (e) {}
			try {
				ukupnoAktivnihMobilnihKorisnika += Number(
					this.state.dashData[i]["activeMobileUsers"]
				);
			} catch (e) {}
						try {
				ukupnoKoristenoProslaNedelja += Number(
					this.state.dashData[i]["IskorisceniObrociProslaNedelja"]
				);
			} catch (e) {}
									try {
				ukupnoRezervisanoProslaNedelja += Number(
					this.state.dashData[i]["RezervisaniObrociProslaNedelja"]
				);
			} catch (e) {}
			Firme.push(
				<CompanyDash
					key={i}
					name={this.state.dashData[i]["Naziv"].toString()}
					pin={this.state.dashData[i][
						"pinPromeneTekuceNedelje"
					].toString()}
					favMeal={
						this.state.dashData[i]["obrok nedelje"]
							.toString()
							.split("/")[0]
					}
					idFirme={this.state.dashData[i]["idFirme"]}
					unFavMeal={
						this.state.dashData[i]["!obrok nedelje"]
							.toString()
							.split("/")[0]
					}
					numOfRes={this.state.dashData[i][
						"broj rezervacija"
					].toString()}
					panelPoruka={this.state.dashData[i][
						"panelPoruka"
					].toString()}
					onlineStatus={this.state.dashData[i][
						"onlineStatus"
					].toString()}
					brojKorisnikaMobilneAplikacije={
						this.state.dashData[i]["activeMobileUsers"]
					}
					brojAktivnihKorisnika={
						this.state.dashData[i]["activePanelUsers"]
					}
					iskoriscenoProsleNedelje={
						this.state.dashData[i]["IskorisceniObrociProslaNedelja"]
					}
										logo={
						this.state.dashData[i]["logo"]
					}
										rezervisanoProsleNedelje={
						this.state.dashData[i]["RezervisaniObrociProslaNedelja"]
					}
					getPorudzbaNaredna={() =>
						this.getPorudzbaNaredna(
							this.state.dashData[i]["idFirme"]
						)
					}
					getPorudzbaTekuca={() =>
						this.getPorudzbaTekuca(
							this.state.dashData[i]["idFirme"]
						)
					}
					getNoviRadnik={() =>
						this.getNoviRadnik(this.state.dashData[i]["idFirme"])
					}
					putPanelPoruka={this.putPanelPoruka}
					sentPanelPoruka={this.sentPanelPoruka}
					PromenaPinaModalHandleOpen={() =>
						this.PromenaPinaModalHandleOpen(
							this.state.dashData[i]["idFirme"],
							this.state.dashData[i]["pinPromeneTekuceNedelje"]
						)
					}
					putUpdateMenu={() =>
						this.putUpdateMenu(this.state.dashData[i]["idFirme"])
					}
					getIzmeniRadnika={() =>
						this.getIzmeniRadnika(this.state.dashData[i]["idFirme"])
					}

				/>
			);
		}
		Firme.reverse();
		Firme.push(
			<MasterDash key={999} name={"Sve Firme"} ukupnoRezervisanoProslaNedelja={ukupnoRezervisanoProslaNedelja} ukupnoKoristenoProslaNedelja ={ukupnoKoristenoProslaNedelja} numOfRes={ukupnoRezervacija} brojKorisnikaMobilneAplikacije={ukupnoAktivnihMobilnihKorisnika} brojAktivnihKorisnika={ukupnoAktivnihKorisnika} />
		);

		Firme.reverse();
		return (
			<div style={{ padding: 4, paddingTop: 21, textAlign: "center" }}>
				<MuiThemeProvider muiTheme={muiTheme}>

					<div
						style={{
							flexDirection: "row",
							display: "flex",
							flexWrap: "wrap",
							paddingTop: 5
						}}
					><RefreshIndicator
      size={50}
      left={this.state.width/2-25}
      top={150}
      loadingColor="#FF9800"
      status={this.state.Loading}/>
						{Firme}
						<Dialog
							title={
								<div style={{ paddingLeft: 15 }}>
									{this.state.porudzNaredData.length > 0
										? "Rezervacije naredna nedelja   " +
											this.state.porudzNaredData[0]["firma"]
										: ""}{" "}
									<CloseIcon
										onClick={
											this.PorudzbaNarednaModalHandleClose
										}
										color={"white"}
										style={{ float: "right", padding: 4 }}
									/>{" "}
								</div>
							}
							modal={false}
							open={this.state.PorudzbaNarednaModalState}
							onRequestClose={
								this.PorudzbaNarednaModalHandleClose
							}
							contentStyle={{
								padding: 15,
								width: "100%",
								maxWidth: "1250px"
							}}
							bodyStyle={{ padding: 5 }}
							titleStyle={{
								background: "#1abc9c",
								color: "white",
								fontSize: 14,
								fontFamily: "Raleway,sans-serif",
								padding: 5,
								textAlign: "left"
							}}
							autoScrollBodyContent={true}
						>
							<Rezervacije
								rezervacije={this.state.porudzNaredData}
							/>
						</Dialog>
						<Dialog
							title={
								<div style={{ paddingLeft: 15 }}>
									{this.state.porudzTekucaData.length > 0
										? "Rezervacije tekuća nedelja   " +
											this.state.porudzTekucaData[0][
												"firma"
											]
										: ""}{" "}
									<CloseIcon
										onClick={
											this.PorudzbaTekucaModalHandleClose
										}
										color={"white"}
										style={{ float: "right", padding: 4 }}
									/>{" "}
								</div>
							}
							modal={false}
							open={this.state.PorudzbaTekucaModalState}
							onRequestClose={this.PorudzbaTekucaModalHandleClose}
							contentStyle={{
								padding: 15,
								width: "100%",
								maxWidth: "1250px"
							}}
							bodyStyle={{ padding: 5 }}
							titleStyle={{
								background: "#1abc9c",
								color: "white",
								fontSize: 14,
								fontFamily: "Raleway,sans-serif",
								padding: 5,
								textAlign: "left"
							}}
							autoScrollBodyContent={true}
						>
							<Rezervacije
								rezervacije={this.state.porudzTekucaData}
							/>
						</Dialog>

						<Dialog
							title={
								<div style={{ paddingLeft: 15 }}>
									Novi Radnik
									<CloseIcon
										onClick={
											this.NoviRadnikModalHandleClose
										}
										color={"white"}
										style={{ float: "right", padding: 4 }}
									/>{" "}
								</div>
							}
							modal={false}
							open={this.state.NoviRadnikModalState}
							onRequestClose={this.NoviRadnikModalHandleClose}
							contentStyle={{
								padding: 25,
								width: "100%",
								maxWidth: "400px"
							}}
							bodyStyle={{ padding: 5 }}
							titleStyle={{
								background: "#1abc9c",
								color: "white",
								fontSize: 14,
								fontFamily: "Raleway,sans-serif",
								padding: 5,
								textAlign: "left"
							}}
							autoScrollBodyContent={true}
						>
							<NoviRadnik
								radneJedinice={this.state.radneJediniceData}
								idfirme={this.state.NoviRadnikSelektovanaFirma}
								postNoviRadnik={this.postNoviRadnik}
							/>
						</Dialog>

						<Dialog
							title={
								<div style={{ paddingLeft: 15 }}>
									Promena PIN-a.
									<CloseIcon
										onClick={
											this.PromenaPinaModalHandleClose
										}
										color={"white"}
										style={{ float: "right", padding: 4 }}
									/>{" "}
								</div>
							}
							modal={false}
							open={this.state.PromenaPinaModalState}
							onRequestClose={this.PromenaPinaModalHandleClose}
							contentStyle={{
								padding: 25,
								width: "100%",
								maxWidth: "400px"
							}}
							bodyStyle={{ padding: 5 }}
							titleStyle={{
								background: "#1abc9c",
								color: "white",
								fontSize: 14,
								fontFamily: "Raleway,sans-serif",
								padding: 5,
								textAlign: "left"
							}}
							autoScrollBodyContent={true}
						>
							<PromenaPina
								putPromeniPin={this.putPromeniPin}
								pinFirme={this.state.PromenaPinaPin}
								idFirme={this.state.PromenaPinaSelektovanaFirma}
							/>
						</Dialog>

					</div>

				</MuiThemeProvider>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Home/HomeScreen.js